import { ref } from 'vue';
import { message } from 'ant-design-vue';
import i18n from '@/i18n';

import Api from '@/api/Api';

import { showErrorMessage } from '@/components/common/errorMessage';

export function useTaskManager(labelRef, inputDataRef, waitLonger) {
	const t = i18n.global.t;
	const isRunning = ref(false);
	const taskId = ref(0);
	const taskGetHandler = response => {
		if (response.status === 'ok') {
			if (response.task_id !== 0) {
				isRunning.value = true;
				taskId.value = response.task_id;
			}
		} else {
			showErrorMessage(response.errors);
		}
	};
	const taskStatusGetHandler = response => {
		if (response.status === 'ok') {
			isRunning.value = response.task_status === 'created';
			if (response.task_status === 'failed') {
				const errorText = response.output_data?.error;
				let errorMessage = '[' + t('taskManager.names.' + labelRef.value) + '] ' + t('taskManager.error') + ' ';
				if (errorText === 'timeout') {
					errorMessage += t('taskManager.errorTimeout');
				} else {
					errorMessage += errorText;
				}
				message.error(errorMessage);
			} else if (response.task_status === 'done') {
				message.success(t('taskManager.success'));
			}
		} else {
			showErrorMessage(response.errors);
		}
	};
	const taskPostHandler = response => {
		if (response.status === 'ok') {
			isRunning.value = true;
			taskId.value = response.task_id;
		} else {
			showErrorMessage(response.errors);
		}
	};
	const taskRun = () => {
		Api.taskPost(labelRef.value, inputDataRef.value, taskPostHandler);
	};
	const timer = setInterval(() => {
		if (isRunning.value) {Api.taskStatusGet(taskId.value, taskStatusGetHandler);}
	}, waitLonger ? 30000 : 10000);
	const unmount = () => clearInterval(timer);

	Api.taskGet(labelRef.value, taskGetHandler);
	return {
		isRunning,
		taskRun,
		unmount,
	};
}
